module.exports = __webpack_public_path__ + "img/ditto-tier-logo-gold.868b49ff.png";